import { createContext } from "react"

export interface SelectContextType {
  elevated?: boolean
}

export const SelectContext = createContext<SelectContextType>({})
